import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { validateTaxPayerForm } from '../../config/Validate';
import moment from 'moment';
import { useRef, useState } from 'react';
import { postAllData } from '../../service/ApiService';
import { ADD_TAXPAYER_MANUALLY } from '../../config/ApiConstant';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { applyFieldRules } from '../../appconfig/Settings';


const AddTaxPayerManually = () => {
  const navigate = useNavigate();
  const toast = useRef<any>(null);

  // error obj
  const [errors, setErrors] = useState<any>({});

  // loading obj
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // tax payer detail obj
  const [manualTaxPayerDetail, setManualTaxPayerDetail] = useState<any>({});

  // on input change
  const onInputChange = (e: any, name: string) => {
    let val;
    val = e?.target?.value ?? e?.value;

    const updatedData = { ...manualTaxPayerDetail, [name]: val };
    const updatedErrors = { ...errors, [name]: '' };

    applyFieldRules(name, val, updatedData, updatedErrors);

    setManualTaxPayerDetail(updatedData);
    setErrors(updatedErrors);
  };

  // submit tax payer form
  const submitTaxpayerForm = async () => {
    const { isError, errors } = validateTaxPayerForm(manualTaxPayerDetail);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);
    try {
      const spouseData = {
        spouse_email: manualTaxPayerDetail.spouse_email,
      };

      const payload = {
        first_name: manualTaxPayerDetail.first_name,
        middle_name: manualTaxPayerDetail.middle_name,
        last_name: manualTaxPayerDetail.last_name,
        phone: manualTaxPayerDetail.mobile,
        email: manualTaxPayerDetail.email,
        dec_marrige_status: manualTaxPayerDetail.dec_marrige_status,

        ...((manualTaxPayerDetail.dec_marrige_status === 'Married' ||
          manualTaxPayerDetail.dec_marrige_status === 'Living common-law') && {
          spouse_details: JSON.stringify(spouseData),
          is_spouse_canadian_resident:
            manualTaxPayerDetail.is_spouse_canadian_resident,
          file_spouse_tax: manualTaxPayerDetail.file_spouse_tax,
        }),
      };
      const response = await postAllData(ADD_TAXPAYER_MANUALLY, payload);
      if (response) {
        navigate('/tax-payer-list');
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };
  return (
    <>
      <Toast ref={toast} />
      <AppBreadcrumb
        currentMenu="TaxList"
        pageName="Manual Tax Payer List"
        pageTitle="Manual Tax Payer List"
        goToPage={true}
      />
      <Card className="bg-white lg:p-2 crud-demo">
        <div className="grid">
          <div className="field col-12 md:col-6 lg:col-4">
            <label>First Name</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputText
                type="text"
                value={manualTaxPayerDetail.first_name || ''}
                placeholder={'Enter first name'}
                onChange={(e) => onInputChange(e, 'first_name')}
              />
            </div>
          </div>
          <div className="field col-12 md:col-6 lg:col-4">
            <label>Middle Name</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputText
                type="text"
                value={manualTaxPayerDetail.middle_name || ''}
                placeholder={'Enter middle name'}
                onChange={(e) => onInputChange(e, 'middle_name')}
              />
            </div>
          </div>
          <div className="field col-12 md:col-6 lg:col-4">
            <label>
              Last Name <span className="required">*</span>
            </label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputText
                type="text"
                value={manualTaxPayerDetail.last_name || ''}
                placeholder={'Enter last name'}
                onChange={(e) => onInputChange(e, 'last_name')}
                className={errors['last_name'] && 'p-invalid'}
              />{' '}
            </div>
            <small className="p-invalid-txt">{errors['last_name']}</small>
          </div>
          <div className="field col-12 md:col-6 lg:col-4">
            <label>
              Enter Mobile Number <span className="required">*</span>
            </label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputText
                value={manualTaxPayerDetail.mobile || ''}
                onChange={(e) => onInputChange(e, 'mobile')}
                placeholder="(123) 456-7890"
                keyfilter="pint"
                maxLength={10}
                className={errors['mobile'] && 'p-invalid'}
              />
            </div>
            <small className="p-invalid-txt">{errors['mobile']}</small>
          </div>
          <div className="field col-12 md:col-6 lg:col-4">
            <label>
              Enter Email <span className="required">*</span>
            </label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputText
                type="email"
                value={manualTaxPayerDetail.email || ''}
                placeholder={'Enter email'}
                onChange={(e) => onInputChange(e, 'email')}
                className={errors['email'] && 'p-invalid'}
              />
            </div>
            <small className="p-invalid-txt">{errors['email']}</small>
          </div>
          <div className="field col-12 md:col-12">
            <label htmlFor="dec_marrige_status">
              On December 31 you were :
            </label>
            <span className="required">*</span>
            <div className="flex gap-4 mt-2">
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_married"
                  name="dec_marrige_status"
                  value="Married"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={
                    manualTaxPayerDetail?.dec_marrige_status === 'Married'
                  }
                />
                <label htmlFor="dec_status_married" className="ml-2">
                  Married
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_common_law"
                  name="dec_marrige_status"
                  value="Living common-law"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={
                    manualTaxPayerDetail?.dec_marrige_status ===
                    'Living common-law'
                  }
                />
                <label htmlFor="dec_status_common_law" className="ml-2">
                  Living common-law
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_widow"
                  name="dec_marrige_status"
                  value="Widow"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={manualTaxPayerDetail?.dec_marrige_status === 'Widow'}
                />
                <label htmlFor="dec_status_widow" className="ml-2">
                  Widow
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_divorced"
                  name="dec_marrige_status"
                  value="Divorced"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={
                    manualTaxPayerDetail?.dec_marrige_status === 'Divorced'
                  }
                />
                <label htmlFor="dec_status_divorced" className="ml-2">
                  Divorced
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_separated"
                  name="dec_marrige_status"
                  value="Separated"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={
                    manualTaxPayerDetail?.dec_marrige_status === 'Separated'
                  }
                />
                <label htmlFor="dec_status_separated" className="ml-2">
                  Separated
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="dec_status_single"
                  name="dec_marrige_status"
                  value="Single"
                  onChange={(e) => onInputChange(e, 'dec_marrige_status')}
                  checked={
                    manualTaxPayerDetail?.dec_marrige_status === 'Single'
                  }
                />
                <label htmlFor="dec_status_single" className="ml-2">
                  Single
                </label>
              </div>
            </div>
            <small className="p-invalid-txt">
              {errors['dec_marrige_status']}
            </small>
          </div>
          {(manualTaxPayerDetail?.dec_marrige_status === 'Married' ||
            manualTaxPayerDetail?.dec_marrige_status ===
            'Living common-law') && (
              <>
                <div className="field col-12 md:col-6 lg:col-4">
                  <label>
                    Spouse Email
                    {manualTaxPayerDetail?.file_spouse_tax === 'true' &&
                      manualTaxPayerDetail?.is_spouse_canadian_resident === '1' && (
                        <span className="required">*</span>
                      )}
                  </label>
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <InputText
                      type="text"
                      value={manualTaxPayerDetail.spouse_email || ''}
                      placeholder={'Enter spouse email'}
                      onChange={(e) => onInputChange(e, 'spouse_email')}
                      className={errors['spouse_email'] && 'p-invalid'}
                    />
                  </div>
                  <small className="p-invalid-txt">
                    {errors['spouse_email']}
                  </small>
                </div>
                <div className="field col-12 md:col-4">
                  <label htmlFor="is_spouse_canadian_resident">
                    Is Spouse Canadian Resident{' '}
                  </label>
                  <span className="required"> *</span>
                  <div className="flex gap-4 mt-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="is_spouse_canadian_resident"
                        name="is_spouse_canadian_resident"
                        value="1"
                        onChange={(e) =>
                          onInputChange(e, 'is_spouse_canadian_resident')
                        }
                        checked={
                          manualTaxPayerDetail?.is_spouse_canadian_resident ===
                          '1'
                        }
                      />
                      <label htmlFor="resident_yes" className="ml-2">
                        Yes
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="is_spouse_canadian_resident"
                        name="is_spouse_canadian_resident"
                        value="0"
                        onChange={(e) =>
                          onInputChange(e, 'is_spouse_canadian_resident')
                        }
                        checked={
                          manualTaxPayerDetail?.is_spouse_canadian_resident ===
                          '0'
                        }
                      />
                      <label htmlFor="resident_no" className="ml-2">
                        No
                      </label>
                    </div>
                  </div>
                  <small className="p-invalid-txt">
                    {errors['is_spouse_canadian_resident']}
                  </small>
                </div>
                {/* file spouse tax */}
                {manualTaxPayerDetail?.is_spouse_canadian_resident ===
                  '1' && (
                    <div className="field col-12 md:col-4">
                      <label htmlFor="is_spouse_canadian_resident">
                        Want to file spouse tax{' '}
                      </label>
                      <span className="required"> *</span>
                      <div className="flex gap-4 mt-2">
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="file_spouse_tax"
                            name="file_spouse_tax"
                            value="true"
                            onChange={(e) =>
                              onInputChange(e, 'file_spouse_tax')
                            }
                            checked={
                              manualTaxPayerDetail?.file_spouse_tax ===
                              'true'
                            }
                          />
                          <label htmlFor="resident_yes" className="ml-2">
                            Yes
                          </label>
                        </div>
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="file_spouse_tax"
                            name="file_spouse_tax"
                            value="false"
                            onChange={(e) =>
                              onInputChange(e, 'file_spouse_tax')
                            }
                            checked={
                              manualTaxPayerDetail?.file_spouse_tax ===
                              'false'
                            }
                          />
                          <label htmlFor="resident_no" className="ml-2">
                            No
                          </label>
                        </div>
                      </div>
                      <small className="p-invalid-txt">
                        {errors['file_spouse_tax']}
                      </small>
                    </div>
                  )}
              </>
            )}
        </div>
        <div className="footer flex justify-content-end">
          <Button
            label="Submit"
            icon="pi pi-check"
            className="common-primary-button"
            onClick={submitTaxpayerForm}
            loading={submitLoading}
          />
        </div>
      </Card>
    </>
  );
};

export default AddTaxPayerManually;
